import React, { useState, useEffect } from 'react';
import { isUserSuperadmin, isAuth } from '../actions/auth';
import CoreSpinner from '../components/_core/CoreSpinner';
import {
  Card,
  CardBody,
  Table,
  Row,
  Col,
} from "reactstrap";
import { get } from '../actions/api';
import { formatDateTimeLocal } from '../actions/helpers';


const styles = {
  Container: {
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    marginLeft: '280px',
    marginRight: '60px',
    marginTop: '80px',
    marginBottom: '130px'
  }
};

function History() {
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    if (!logs) {
      getLogs();
    }
  });

  async function getLogs() {
    const data = await get("print-logs" + (isUserSuperadmin() ? `?business_id=${isAuth().business.id}` : ""));
    setLogs(data || []);
  }

  function formatDate(dateStr) {
    return formatDateTimeLocal(dateStr);
  }

  function formatDateShort(dateStr) {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return d.toLocaleDateString();
  }

  return (
    <>
      {!logs && <CoreSpinner loading={!logs} />}
      <div className="content1" style={styles.Container}>
        <Row>
          <Col md={"12"}>
            <Card>
              <CardBody>
                <Table className="tablesorter" responsive>
                  <thead className="text-primary">
                    <tr>
                      <th style={{ fontWeight: 'bold' }}>Date</th>
                      <th style={{ fontWeight: 'bold' }}>User</th>
                      <th style={{ fontWeight: 'bold' }}>Company</th>
                      <th style={{ fontWeight: 'bold' }}>Template</th>
                      <th style={{ fontWeight: 'bold' }}>File Name</th>
                      <th style={{ fontWeight: 'bold' }}>Date Range</th>
                      <th style={{ fontWeight: 'bold' }}>Records</th>
                    </tr>
                  </thead>
                  {logs &&
                    <tbody>
                      {logs.map(log => (
                        <tr key={log.id}>
                          <td>{formatDate(log.created_at)}</td>
                          <td>{log.user_name || '-'}</td>
                          <td>{log.business_name || '-'}</td>
                          <td>{log.template_name || '-'}</td>
                          <td>{log.file_name || '-'}</td>
                          <td>
                            {log.date_range_min || log.date_range_max
                              ? `${formatDateShort(log.date_range_min)} - ${formatDateShort(log.date_range_max)}`
                              : '-'
                            }
                          </td>
                          <td>{log.record_count}</td>
                        </tr>
                      ))}
                      {logs.length < 1 &&
                        <tr>
                          <td style={{ padding: 10 }}>No print history</td>
                        </tr>
                      }
                    </tbody>
                  }
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default History;
